import * as React from "react";
const SvgPtLabel = () => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, fill: "none" }, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M7.216 11.26h1.54c.952 0 1.358-.462 1.358-1.12 0-.518-.392-.84-1.036-.84H7.776z"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12M5.858 7.2h3.514c2.058 0 3.136 1.12 3.136 2.674 0 1.946-1.386 3.486-3.906 3.486H6.614L5.578 17h-2.52zM16.077 17h-2.52l2.128-7.588h-2.59l.63-2.212h7.56l-.63 2.212h-2.422z",
    clipRule: "evenodd"
  }
));
export default SvgPtLabel;
